import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1e3a8a] text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="mb-6">
              <h2 className="text-3xl font-bold mb-2">BRISE</h2>
              <p className="text-[#fbbf24] text-lg font-semibold">Bharat Renewable Infrastructure<br />& Solar Energy Pvt. Ltd.</p>
            </div>
            <p className="text-gray-300 text-lg leading-relaxed mb-6">
              Building India's sustainable energy future through world-class manufacturing and EPC excellence.
            </p>
            <div className="flex gap-4">
              <a 
                href="#" 
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#fbbf24] hover:text-[#1e3a8a] transition-all duration-300"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#fbbf24] hover:text-[#1e3a8a] transition-all duration-300"
              >
                <Twitter className="h-5 w-5" />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#fbbf24] hover:text-[#1e3a8a] transition-all duration-300"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-[#fbbf24]">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-[#fbbf24] transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-[#fbbf24] transition-colors duration-200">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-300 hover:text-[#fbbf24] transition-colors duration-200">
                  Products & Services
                </Link>
              </li>
              <li>
                <Link to="/founders" className="text-gray-300 hover:text-[#fbbf24] transition-colors duration-200">
                  Founder's Desk
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-[#fbbf24] transition-colors duration-200">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-[#fbbf24]">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-[#fbbf24] flex-shrink-0 mt-1" />
                <span className="text-gray-300">Dehradun, Uttarakhand, India</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="h-5 w-5 text-[#fbbf24] flex-shrink-0 mt-1" />
                <span className="text-gray-300">+91 6396455851</span>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-5 w-5 text-[#fbbf24] flex-shrink-0 mt-1" />
                <span className="text-gray-300">pulkit.garg@briseenergy.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-300 text-center md:text-left">
              © 2026 BRISE Private Limited. All Rights Reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-gray-300 hover:text-[#fbbf24] transition-colors duration-200">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-300 hover:text-[#fbbf24] transition-colors duration-200">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
